<script setup lang="ts">
import { Button } from '@dashhudson/dashing-ui/button';
import { computed, ref } from 'vue';

import { useSendUnifiedUserPrompt } from '@/components/VisionAi/composables/useSendUnifiedUserPrompt';
import { VISION_AI_SUMMARY_INTERACTIONS } from '@/components/VisionAi/constants';
import type { CannedPromptButtonWidgetData } from '@/components/VisionAi/widgets/visionWidget.types';
import { useVisionAiStore } from '@/stores/vision-ai';

const { widgetData } = defineProps<{
  widgetData: CannedPromptButtonWidgetData;
  narrowMode?: boolean;
}>();

const emit = defineEmits<{
  onWidgetClick: [interaction: string];
}>();

const visionAiStore = useVisionAiStore();
const promptText = ref('');
const { sendUnifiedUserPrompt } = useSendUnifiedUserPrompt();

async function handleSubmit() {
  const rawPrompt = promptText.value;
  promptText.value = '';
  await sendUnifiedUserPrompt(rawPrompt);
}

const disabled = computed(() => visionAiStore.loadingMessageInCurrentConversation);

async function handleClick() {
  emit('onWidgetClick', VISION_AI_SUMMARY_INTERACTIONS.CANNED_PROMPT_CLICK);
  promptText.value = widgetData.canned_prompt || widgetData.label;
  await handleSubmit();
}
</script>

<template>
  <Button
    severity="primary"
    class="max-w-full"
    :label="widgetData.label"
    :icon="widgetData.icon"
    :disabled="disabled"
    data-testid="canned-prompt-button-widget"
    @click="handleClick"
  />
</template>
